import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BarService } from '../bar.service';

@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.sass'],
})
export class SideNavBarComponent implements OnInit {
  @Input('menu') menu: any;
  @Output('onClose') closeSideNav: EventEmitter<any> = new EventEmitter();

  constructor(private barService: BarService) {}

  ngOnInit(): void {
    // this.menuList = this.barService.getList();
  }

  public closeNav() {
    this.closeSideNav.emit();
  }
}
